module.exports = __webpack_public_path__ + "img/3-low.87391bd5.jpg";